import { render } from "./UEInsuranceWorkerEditView.vue?vue&type=template&id=b60b6d14&scoped=true"
import script from "./UEInsuranceWorkerEditView.vue?vue&type=script&lang=js"
export * from "./UEInsuranceWorkerEditView.vue?vue&type=script&lang=js"

import "./UEInsuranceWorkerEditView.vue?vue&type=style&index=0&id=b60b6d14&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b60b6d14"]])

export default __exports__